import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import store from "./store/index.js";
import util from "./mixins/DomainMixin";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faInfoCircle, faHome, faArrowLeft} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
window.$ = require('jquery');
import 'bootstrap/dist/js/bootstrap.bundle';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue';
import BootstrapVue from 'bootstrap-vue';
import './static/style.css';
import * as VeeValidate from 'vee-validate';

library.add(faInfoCircle, faArrowLeft, faHome);

Vue.mixin(util);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VeeValidate, {classes: true});


new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
